import { useEvent } from "../../../lib/hooks/useEvent";
import close_icon from "../../../assets/close_small.svg";
import { handleCheck } from "../../../lib/utils/stencilUtils";
import { useCategories } from "../../../lib/hooks/useCategories";
import { useStencils } from "../../../lib/hooks/useStencils";
import { useStencilWeeks } from "../../../lib/hooks/useStencilWeeks";

// stencil information sidebar rendering:
const StencilSidebar = ({
  onClose,
  item,
  onEdit,
  onDelete,
  onArchive,
  setIsFullScreen,
  setSelectedStencil,
  selectedStencil,
  setKeywords,
}) => {
  const { event } = useEvent();
  const { categories } = useCategories();
  const { stencils, setStencils } = useStencils();
  const { stencilWeeks, setStencilWeeks } = useStencilWeeks();

  // stencil has been selected, display info:
  return (
    <div className="select-stencil-sidebar col-3" style={{ paddingTop: "5px" }}>
      <div className="d-flex flex-column scrollable-rhs scroll-invis">
        <div className="d-flex justify-content-end">
          <button onClick={onClose} className="select-stencil-sidebar">
            <img src={close_icon} width={36} alt="Close sidebar" />
          </button>
        </div>

        {item && (
          <>
            {" "}
            <h2 className="stencil-info" id="stenctilName">
              {`${item.name}`}
            </h2>
            <p className="stencil-info" id="stencilCategory">
              {`Category: ${categories[item.category_id - 1].name}`}
            </p>
            {item.subcategory !== "" && (
              <p className="stencil-info" id="stencilSubCategory">
                {`Subcategory: ${item.subcategory}`}
              </p>
            )}
            <p className="stencil-info" id="stencilId">
              {`${item.id}`}
            </p>
            {item.source !== "" && (
              <p className="stencil-info" id="stencilId">
                {`Source: ${item.source}`}
              </p>
            )}
            <div className="d-flex justify-content-center p-3">
              <img
                id="stencil-image"
                src={`/api/stencils/files/${item.image_name}`}
                alt={`${item.name}`}
                width={100}
                style={{ textAlign: "center", cursor: "pointer" }}
                onClick={() => setIsFullScreen(true)}
              />
            </div>
            <div style={{ textAlign: "center" }}>
              {!!event?.isActive && !selectedStencil.archived && (
                <form id="check-week" style={{ display: "inline-block" }}>
                  {[...Array(event?.num_weeks)].map((_, index) => (
                    <label key={index + 1} style={{ color: "white" }}>
                      <input
                        id={`${item.id}week${index + 1}`}
                        type="checkbox"
                        style={{ margin: "10px" }}
                        checked={item[`isSelectedWeek${index + 1}`] === 1}
                        onChange={() =>
                          handleCheck(
                            item,
                            index + 1,
                            setSelectedStencil,
                            selectedStencil,
                            setKeywords,
                            stencils,
                            setStencils,
                            stencilWeeks,
                            setStencilWeeks
                          )
                        }
                      />
                      W{index + 1}
                    </label>
                  ))}
                </form>
              )}
            </div>
            <br />
            <p className="stencil-info" id="stencilExpectedTraceTime">
              Expected Trace Time: <b>{item.expected_trace_time}</b> min
            </p>
            <p className="stencil-info" id="stencilExpectedCarveTime">
              Expected Carve Time: <b>{item.expected_carve_time}</b> min
            </p>
            <p className="stencil-info" id="stencilTimesUsed">
              Times Used: <b>{item.times_used}</b>
            </p>
            <p className="stencil-info" id="stencilLastYearUsed">
              Last Year Used: <b>{item.last_year_used || "null"}</b>
            </p>
          </>
        )}
      </div>
      <hr style={{ color: "white" }} />
      <div style={{ paddingBottom: "5px" }}>
        <button
          className="sidebar-button"
          style={{ backgroundColor: "#ed4709" }}
          id="update-stencil"
          onClick={onEdit}
        >
          Update Stencil
        </button>
        <button
          className="sidebar-button"
          style={{ backgroundColor: "#ed4709", marginTop: "3px" }}
          id="delete-stencil"
          onClick={onDelete}
        >
          Delete Stencil
        </button>
        <button
          className="sidebar-button"
          style={{ backgroundColor: "#ed4709", marginTop: "3px" }}
          id="archive-stencil"
          onClick={onArchive}
        >
          {selectedStencil.archived === 1
            ? `Unarchive Stencil`
            : `Archive Stencil`}
        </button>
      </div>
    </div>
  );
};

export default StencilSidebar;
